import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { initSentry } from './app/core/sentry/sentry.init';

initSentry('parkinghub', 'agendamento-web');

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
